module.exports = __webpack_public_path__ + "static/img/tv1.32f3dbc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/companies/marketmaker/assets/tv1.jpg
// module id = w2pO
// module chunks = 1